<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 关键：设置透明背景，让WebView可以透过看到底层应用 */
html {
  background-color: transparent !important;
  background: transparent !important;
}

body {
  margin: 0;
  padding: 0;
  background-color: transparent !important;
  background: transparent !important;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: transparent !important;
  background: transparent !important;
}
</style>
